namespace GeniuzPOS.SalePromoCamp {
    export interface PsPromoCampaignRow {
        Id?: number;
        PromoCampaign?: string;
        PromoCampName?: string;
        FullName?: string;
    }

    export namespace PsPromoCampaignRow {
        export const idProperty = 'PromoCampaign';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'SalePromoCamp.PsPromoCampaign';
        export const lookupKey = 'SalePromoCamp.PsPromoCampaign';

        export function getLookup(): Q.Lookup<PsPromoCampaignRow> {
            return Q.getLookup<PsPromoCampaignRow>('SalePromoCamp.PsPromoCampaign');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            PromoCampaign = "PromoCampaign",
            PromoCampName = "PromoCampName",
            FullName = "FullName"
        }
    }
}
